require('./account.component.scss');

/*@ngInject*/
class AccountController {
  constructor(
    $scope,
    $element,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$scope.fact = this.fact;
  }

  showAccounts() {
    const rect = this.$element.context.getBoundingClientRect();
    const menu = this.$element.find('div > div');

    menu.css('left', rect.left);
    menu.css('top', rect.top + 10);
    menu.css('visibility', 'visible');
  }

  hideAccounts() {
    this.$element.find('div > div').css('visibility', 'hidden');
  }

  get accountEmails(){
    let accountsEmails = [];
    for (let key in this.fact.accounts) {
      accountsEmails = accountsEmails.concat(this.fact.accounts[key]);
    }
    return accountsEmails;
  }

  get accounts() {
    return this.fact.accounts ? this.fact.accounts[this.accountKey] || [] : [];
  }

  get alias() {
    // return this.fullName ? this.fullName : (this.userName ? this.userName: this.account);
    return this.fullName || this.userName || this.accountKey;
  }

  get id() {
    return this.accounts.length ? this.accounts[0].id : 0;
  }

  get userName() {
    return this.accounts.length ? this.accounts[0].user_name : '';
  }

  get fullName() {
    return this.accounts.length ? this.accounts[0].full_name : '';
  }
}

export const AccountComponent = {
  template: require('./account.component.html'),
  controller: AccountController,
  bindings: {
    accountKey: '<',
    fact: '<',
    dkey: '<',
  },
  // resolve: '^facts'
};



// WEBPACK FOOTER //
// ./src/facts/account/account.component.js